import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const [visibleTitle, setVisibleTitle] = useState(0);

  useEffect(() => {
    setVisibleTitle(0);
  }, []);

  const footerLinks = [
    {
      title: "Home",
      link: "/",
      icon: <img id="reels2" alt='dfd' src='/home.svg' className={location.pathname === "/" ? "w-[20px] h-[20px] brightness-[0.1]" : "w-[20px] h-[20px]"} />
    },
    {
      title: "Earn",
      link: "/earn",
      icon: <img alt='dfd' src='/earn.png' className={location.pathname === "/earn" ? "w-[20px] h-[20px] brightness-[0.1]" : "w-[20px] h-[20px]"} />
    },
    {
      title: "Frens",
      link: "/ref",
      icon: <img alt='dfd' src='/ref.svg' className={location.pathname === "/ref" ? "w-[20px] h-[20px] brightness-[0.1]" : "w-[20px] h-[20px]"} />
    },
    {
      title: "Ranks",
      link: "/leaderboard",
      icon: <img alt='dfd' src='/leaders.png' className={location.pathname === "/leaderboard" ? "w-[20px] h-[20px] brightness-[0.1]" : "w-[20px] h-[20px]"} />
    },
  ]

  return (
    <div className="w-full flex z-30 relative items-center justify-center space-x-2 py-1 bg-[#161718]"> {/* এখানে bg-[#5e5e5e] যোগ করা হয়েছে */}
      {footerLinks.map((footer, index) => (
        <NavLink 
          key={index}
          to={footer.link}
          className={({ isActive }) => {
            return `
              ${
                isActive
                  ? "w-[25%] flex flex-col rounded-[8px] items-center justify-center text-primary text-[11px]"
                  : "w-[25%] flex flex-col space-y-[1px] rounded-[8px] items-center justify-center text-[11px]"
              }
            `;
          }}
          onClick={() => setVisibleTitle(index)}
        >
          <span 
            id="reels" 
            className={location.pathname === `${footer.link}` ? 
              `w-[50px] h-[30px] bg-btn mb-[4px] flex flex-col rounded-[20px] items-center justify-center text-[11px]`
              : "w-[50px] h-[30px] flex flex-col space-y-[1px] rounded-[8px] items-center justify-center text-primary text-[11px]"
            }
          >
            {footer.icon}
          </span>
          <span className="font-medium" style={{ display: visibleTitle === index ? 'block' : 'none' }}>
            {footer.title}
          </span>
        </NavLink>
      ))}
    </div>
  );
};

export default Footer;